import axios from 'axios';
import type { AxiosInstance, AxiosResponse } from 'axios';
import type { ApiResponse } from '@/types/api';

// 从环境变量获取 API 基础 URL，默认为 localhost:8080
// const BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8080';

const instance: AxiosInstance = axios.create({
  baseURL: `/api/admin/v1/auth`,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// 请求拦截器：自动注入 Token
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('admin_token');
    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器：统一处理业务错误
instance.interceptors.response.use(
  (response: AxiosResponse<ApiResponse>) => {
    const { data } = response;
    // 后端约定 code === 0 为成功
    if (data.code === 0) {
      return response;
    }
    // 业务错误处理
    const errorMessage = data.message || '请求失败';
    console.error('API Error:', errorMessage);
    // 这里可以触发全局 Message 提示，例如: message.error(errorMessage);
    return Promise.reject(new Error(errorMessage));
  },
  (error) => {
    // HTTP 状态码错误处理
    if (error.response) {
      const { status } = error.response;
      if (status === 401) {
        // Token 过期或无效，跳转登录
        localStorage.removeItem('admin_token');
        window.location.href = '/login';
      } else if (status === 403) {
        console.error('权限不足');
      }
    }
    return Promise.reject(error);
  }
);

export default instance;